// eslint-disable-next-line eol-last
export const SET_USER = "SET_USER"
export const SET_TOKEN = "SET_TOKEN"
export const LOGOUT = "LOGOUT"
export const SET_USER_DETAIL = "SET_USER_DETAIL"
